import { Component, HostBinding, HostListener, Input } from "@angular/core";

interface IClearStateManager {
    resetState(): void;
}

@Component({
    selector: "clear-state-cta",
    templateUrl: "./clear-state.component.html",
})
export class CommonClearStateComponent {
    @HostBinding("style.cursor") public cursorStyle = "pointer";
    @Input() public manager: IClearStateManager;
    @Input() public buttonLabel = "Clear All";
    @Input() public ctaDisabled = false;

    @HostListener("click")
    public clearState() {
        this.manager.resetState();
    }
}
